const { REACT_APP_API_ENDPOINT,REACT_APP_API_NODE_ENDPOINT } = process.env;

const BASE_URL = REACT_APP_API_ENDPOINT;
export const API_BASE_URL = `${BASE_URL}/api/v1`;
const API_URL = "https://chatbot.ibism.com"
// const API_URL_DEV = "http://localhost:4343"
const NODE_BASE_URL = REACT_APP_API_NODE_ENDPOINT

const AppUrl = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  OPENAI: `${API_BASE_URL}/openAi`,
  FILES: `${API_URL}/api/`,
  LOGIN_URL: `${API_URL}/api/login`,
  SIGNUP_URL: `${API_URL}/api/register`,
  GET_FILE: `${API_URL}/api/get-data`,
  SAVE_FILE: `${API_URL}/api/save-data`,
  UPLOAD_FILE: `${API_URL}/api/upload-data`,
  CUSTOM_FETCH: `${API_URL}/api/custom-fetch`,
  GET_JSON: `${API_URL}/api/get-json`,
  HTML_DETAIL: `${API_URL}/api/get-html-details`,
  SEND_MAIL:`${API_URL}/api/send-mail`,
  HISTORY:`${API_URL}/api/history`,
  DASHBOARD:`${API_BASE_URL}/dashboard`,
  FETCH_PROMPT:`${API_BASE_URL}/prompts`,
  FETCH_KNOWLEDGE:`${API_BASE_URL}/files`,
  WEB_SCRAPPER:`${NODE_BASE_URL}/api/webscrapper`,
  USERS:`${API_URL}/api/users`,
  UPLOAD: `${API_URL}/api/upload`,
  ADD_TENANT: `${API_BASE_URL}/tenant/create`,
  TENANT: `${API_BASE_URL}/tenants`,
  CONVERSATION: `${API_BASE_URL}/history`,
  TOGGLE_TENANT_STATUS: `${API_BASE_URL}/tenants/status`,
  TOGGLE_BOT_STATUS: `${API_BASE_URL}/bots/status`,
  DELETE_BOT: `${API_BASE_URL}/delete-bot`,
  UPDATE_BOT: `${API_BASE_URL}/update-bot-details`,

};

Object.freeze(AppUrl);
export default AppUrl;
